import React from 'react';
import { createRoot } from 'react-dom/client';

import Pricing from 'Pricing';

document.addEventListener('DOMContentLoaded', function load() {
  const id = 'pricing';
  const node = document.getElementById(id);

  if (!node) return; // Ensure the node exists before calling createRoot

  const root = createRoot(node);
  root.render(<Pricing />);
});
